module.exports = __webpack_public_path__ + "img/share_bar_icon.e6961bed.png";